import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { SapDocumentTypeService } from '../proxy/controlling/controllers/sap-document-type.service';
FieldBuilder.setNamespace('Controlling');

export const CONTRACTTYPESAPPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.text('sglIndicator', 'Entity.ContractTypeSapParameter.SglIndicator')
    .required()
    .build(),
  FieldBuilder.foreignKey('sapDocumentTypeId', 'Entity.SapDocumentType', SapDocumentTypeService)
    .displayFromNested('sapDocumentType.name')
    .sortBy('sapDocumentType.name')
    .build(),
];

export const CONTRACTTYPESAPPARAMETER_CONFIG = {
  entityName: 'ContractTypeSapParameter',
  localizationKey: 'Controlling::Entity.ContractTypeSapParameter',
  fields: CONTRACTTYPESAPPARAMETER_FIELDS,
  permission: 'ControllingContract.ContractTypeSapParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
